import React from 'react';
import { TextField, Box } from '@mui/material';
import { FormikValues } from 'formik';
import NavigationBar from '../../components/NavigationBar/NavigationBar';
import BrandButton from '../../components/BrandButton/BrandButton';
import { LocalizePropType } from 'getaway-data-layer';
import { GA_TITLES } from '../../../utils';
import './EmailLoginView.less';

type props = {
  localize: LocalizePropType;
  formik: FormikValues;
  onClose: () => void;
  turnstileRef: any;
  onPressSignup: () => void;
  isTurnstileLoading?: boolean;
};

const EmailLoginView = ({
  localize,
  formik,
  onClose,
  turnstileRef,
  onPressSignup,
  isTurnstileLoading = false,
}: props) => {
  return (
    <div className="screen-container">
      <NavigationBar
        title={localize('login.email.title')}
        description={localize('login.email.desc')}
        showHelp
        onClose={onClose}
        showArrowBack
      />
      <div className="screen-body">
        <Box component="form" noValidate onSubmit={formik.handleSubmit}>
          <TextField
            data-testid="ForgotPasswordView-emailInput"
            required
            fullWidth
            id="email"
            className="form-input"
            label={localize('login.email.placeholder')}
            helperText={(formik.touched.email && formik.errors.email) || ''}
            error={formik.touched.email && Boolean(formik.errors.email)}
            variant="standard"
            type="email"
            autoComplete="email"
            {...formik.getFieldProps('email')}
          />
          <div ref={turnstileRef} className="turnstile-widget" />

          <div
            className="signup-footnote-container"
            style={{
              position: 'unset',
              width: '100%',
              marginTop: 30,
              padding: 0,
            }}
          >
            <BrandButton
              id={GA_TITLES.AUTH.LOGIN}
              title={localize('login.email.button.title')}
              containerStyles={{ position: 'unset', width: '100%' }}
              formik={formik}
              disabled={isTurnstileLoading}
            />

            <div onClick={onClose} className="login-footnote">
              <div
                data-testid="LoginView-footnoteSignupBtn"
                className="login-view-forget-text "
              >
                {localize('login.with.password')}
              </div>
            </div>
          </div>
          <div className="signup-footnote-container">
            <div onClick={onPressSignup} className="login-footnote">
              <div className="login-footnote-text">
                {localize('login.footnote.signup.text')}
              </div>
              <div
                data-testid="LoginView-footnoteSignupBtn"
                className="signup-footnote-action"
              >
                {localize('login.footnote.signup.action')}
              </div>
            </div>
          </div>
        </Box>
      </div>
    </div>
  );
};

export default EmailLoginView;
